import React, { useMemo } from "react";
import { TabPane, Tab } from "semantic-ui-react";
import CardSegmentOrgan from "./CardSegmentOrgan";
import CardSegmentPost from "./CardSegmentPost";

type CardSegmentEditContentType = {
    setProp: any;
    SegmentTargetSequence: any;
    runSequence: any;
    setModalParam: any;
    languageUX: "en" | "th";
}

const CardSegmentEditContent = (props: CardSegmentEditContentType) => {

  const optionsOrgans = useMemo(() => {

    if (props.SegmentTargetSequence?.organsMaster?.length > 0 && props.languageUX) { 
      return props.SegmentTargetSequence?.organsMaster?.map((i: any) => ({ key: i.value, value: i.value , text: props.languageUX === "th" ? i.label_th : i.label_en }) )
    }     
    return []
  }, [props.SegmentTargetSequence?.organsMaster, props.languageUX])
  // console.log('CardSegmentEditContent props.languageUX: ', props.languageUX);
  // console.log('CardSegmentEditContent props.SegmentTargetSequence?.organsMaster: ', props.SegmentTargetSequence?.organsMaster);
  // console.log('CardSegmentEditContent optionsOrgans: ', optionsOrgans);


  const panes = [
    {
      menuItem: "Status Organ (สถานะอวัยวะ)",
      render: () => (
        <TabPane attached={false} style={{height: "calc(100% - 50px)"}} >
          <CardSegmentOrgan 
            SegmentTargetSequence={props.SegmentTargetSequence} 
            setProp={props.setProp}
            runSequence={props.runSequence}
            setModalParam={props.setModalParam}
            optionsOrgans={optionsOrgans}
            />
        </TabPane>
      ),
    },
    {
      menuItem: "Post (โพสต์)",
      render: () => (
        <TabPane attached={false} style={{height: "calc(100% - 50px)"}} >
          <CardSegmentPost
            SegmentTargetSequence={props.SegmentTargetSequence} 
            setProp={props.setProp}
            runSequence={props.runSequence}
            setModalParam={props.setModalParam}
            optionsOrgans={optionsOrgans}
          />
        </TabPane>
      ),
    },
  ];
  return (
    <Tab
      style={{ width: "100%", height: "100%" }}
      menu={{ secondary: true, pointing: true }}
      panes={panes}
    />
  );
};

export default CardSegmentEditContent;
